import { ValidationErrors } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { ValidatorFn } from '@angular/forms/src/forms';
import * as moment from 'moment';

// const patt = new RegExp(/^(\+?56)?(\s?)(0?9)(\s?)[98765432]\d{7}$/);

const patt = new RegExp(/^\d{9}$/);
const pattAplphanumeric = /^(?=.*[A-z])(?=.*[0-9])[A-z0-9]+$/;
const pattEmail = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);

export function validatePhone(control: AbstractControl) {
  if (!control || !control.value) {
    return null;
  }

  if (control.value.length !== 9 || !control.value.match('^[0-9]*$')) {
    return { validPhone: true };
  }
  return null;
}

export function validateDate(control: AbstractControl) {
  let fechaNacimientoDeRescate = control.root.value['dateRescatadoForm'];
  let fechaNacimientoDataPicker = control.value;

  fechaNacimientoDeRescate = moment(
    fechaNacimientoDeRescate,
    'YYYY-MM-DD'
  ).format('DD-MM-YYYY');
  fechaNacimientoDataPicker = moment(
    fechaNacimientoDataPicker,
    'YYYY-MM-DD'
  ).format('DD-MM-YYYY');

  if (!control || !control.value) {
    return null;
  }

  if (fechaNacimientoDeRescate !== fechaNacimientoDataPicker) {
    return { validateDate: true };
  }
  return null;
}


export function validateDateBeneficiarios(control: AbstractControl) {
  const formDate = new Date(control.value);
  const currentDate = new Date();

  if (!control || !control.value) {
    return null;
  }

  if (formDate >= currentDate) {
    return { validateDateBeneficiarios: true };
  }
  return null;
}




export function validateMinorDate(control: AbstractControl) {
  const formDate = new Date(control.value);
  const currentDate = new Date();
  currentDate.setFullYear(currentDate.getFullYear() - 150);
  if (!control || !control.value) {
    return null;
  }

  if (formDate < currentDate) {
    return { validateMinorDate: true };
  }
  return null;
}

export function rutExist(beneficiaries: any): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control) {
      return null;
    }
    const rutNoDv = control.value.slice(0, -1);
    const rutDivision = rutNoDv.replace('-', '.');
    const rutBeneficiary = Number(rutDivision.split('.').join(''));
    const dvBeneficiary = control.value.slice(-1).toString();

    if (
      beneficiaries.filter(
        x => x.rut === rutBeneficiary && x.dv === dvBeneficiary
      ).length !== 0
    ) {
      return { rutExist: true };
    }
    return null;
  };
}

// export function Validate85(monto: number): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     let valorrescatadoForm: string = control.value;
//     valorrescatadoForm = valorrescatadoForm.replace(/[$.]/g, '');
//     const checkTipoRescate = control.root.value['checkBoxTipo'];
//     if (!control) {
//       return null;
//     }
//     if (
//       Number(valorrescatadoForm) > monto * 0.85 &&
//       checkTipoRescate == 'parcial'
//     ) {
//       return { valor85: true };
//     }
//     return null;
//   };
// }

export function valirut(control: AbstractControl) {
  if (!control || !control.value) {
    return null;
  }
  if (!/^([0-9]+[.]{1}){2}[0-9]+[-|‐][0-9kK]{1}$/.test(control.value)) {
    return { valirut: true };
  }
  return null;
}

export function validateEmail(control: AbstractControl) {
  if (!control) {
    return null;
  }
  if (control.value !== '' && !pattEmail.test(control.value)) {
    return { email: true };
  }
  return null;
}

export function validate14(control: AbstractControl) {
  if (!control) {
    return null;
  }
  if (control.value.toString().length > 14 || Number(control.value) == 0) {
    return { validate14: true };
  }
  return null;
}

export function validateMonto0(control: AbstractControl) {
  if (!control) {
    return null;
  }

  if (control.value <= 0 || control.value === 0) {
    return { valor0: true };
  }
  return null;
}

export function Validate85(monto: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let valorrescatadoForm: string = control.value;
    valorrescatadoForm = valorrescatadoForm.replace(/[$.]/g, '');
    const checkTipoRescate = control.root.value['checkBoxTipo'];

    if (!control) {
      return null;
    }
    if (
      Number(valorrescatadoForm) > Math.trunc(monto * 0.85) &&
      checkTipoRescate === 'parcial'
    ) {
      return { valor85: true };
    }
    return null;
  };
}


export function Validate85_57b(monto: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let valorrescatadoForm: string = control.value;
    const checkTipoRescate = control.root.value['checkBoxTipo'];

    if (!control) {
      return null;
    }
    if (
      Number(valorrescatadoForm) > Math.trunc(monto * 0.85) &&
      checkTipoRescate === 'parcial'
    ) {
      return { valor85: true };
    }
    return null;
  };
}

export function ValidateSubAccount(monto: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let valorrescatadoForm: string = control.value;
    valorrescatadoForm = valorrescatadoForm.replace(/[$.]/g, '');

    if (!control) {
      return null;
    }
    if (
      Number(valorrescatadoForm) > monto
    ) {
      return { valorOverTotal: true };
    }
    return null;
  };
}

export function ValidateNumber(monto: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let valorrescatadoForm: string = control.value;
    valorrescatadoForm = valorrescatadoForm.replace(/[$.]/g, '');
    const pattOnlyNumber = new RegExp(/^[0-9]+$/);

    if (!control) {
      return null;
    }
    if (
      !pattOnlyNumber.test(valorrescatadoForm)
    ) {
      return { notNumber: true };
    }
    return null;
  };
}



export function ValidateMaximoParcial(
  monto: number,
  monto2016: number,
  monto2017: number
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control) {
      return null;
    }

    const checkTipoRescate = control.root.value['checkBoxTipo'];
    let monto2016Form = '0';
    let monto2017Form = '0';

    if (control.root.value['rescatadoSubCuenta2016']) {
      monto2016Form = control.root.value['rescatadoSubCuenta2016'].replace(
        /[$.]/g,
        ''
      );
    }

    if (control.root.value['rescatadoSubCuenta2017']) {
      monto2017Form = control.root.value['rescatadoSubCuenta2017'].replace(
        /[$.]/g,
        ''
      );
    }

    if (checkTipoRescate === 'parcial') {
      if (Number(control.value) > Math.round(monto * 0.85)) {
        return { valor85: true };
      }
      if (Number(monto2016Form) > Number(monto2016)) {
        return { superaSaldoCuenta: true };
      }
      if (Number(monto2017Form) > Number(monto2017)) {
        return { superaSaldoCuenta: true };
      }
    }
  };
}

export function validateAlphanumeric(control: AbstractControl) {
  if (!control || !control.value) {
    return null;
  }
  if (
    control.value !== '' &&
    !control.value.match('^(?=.*[A-z])(?=.*[0-9])[A-z0-9]+$')
  ) {
    return { aplphanumeric: true };
  }
  return null;
}

export function validateNumCte(control: AbstractControl) {
  if (!control || !control.value) {
    return null;
  }
  if (
    control.value !== '' &&
    !control.value.match('^(?=.*[A-z])(?=.*[0-9])[A-z0-9]+$')
  ) {
    return { aplphanumeric: true };
  }
  return null;
}

export function superaSaldoCuenta(monto: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control) {
      return null;
    }

    let valorrescatadoForm = '0';

    if (control.value) {
      valorrescatadoForm = control.value;
      valorrescatadoForm = valorrescatadoForm.replace(/[$.]/g, '');
    }

    if (
      Number(valorrescatadoForm) > 0 &&
      Number(valorrescatadoForm) > Math.round(monto)
    ) {
      return { superaSaldoCuenta: true };
    }
  };
}
